import { useQuery } from '@tanstack/react-query';
import { candidateExperienceService } from '../services/candidate-experience.service';
import { useCandidateSession } from '../context/CandidateSessionContext';
import { useCandidateExperienceMutations } from './useCandidateExperienceMutations';
import type { CandidateExperienceMutations } from './useCandidateExperienceMutations';
import type { Experience } from '@/features/experiences/types/experience.types';

interface CandidateExperiencesResult extends CandidateExperienceMutations {
  experiences: Experience[] | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
}

export function useCandidateExperiences(): CandidateExperiencesResult {
  const { isAnonymous, shareId } = useCandidateSession();
  const queryKey = isAnonymous
    ? ['candidate-experiences', 'anonymous', shareId]
    : ['candidate-experiences'];

  const query = useQuery({
    queryKey,
    queryFn: () =>
      isAnonymous
        ? candidateExperienceService.listByShareId(shareId!)
        : candidateExperienceService.list(),
  });

  const mutations = useCandidateExperienceMutations({ queryKey, isAnonymous, shareId });

  return {
    experiences: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    ...mutations,
  };
}
